import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
	return (
		<Sonner
			theme="dark"
			className="toaster"
			toastOptions={{
				style: {
					background: "var(--float)",
					color: "var(--tx-primary)",
					border: "1px solid var(--line)"
				},
				classNames: {
					toast: "group toast font-medium",
					title: "!text-tx-primary !font-medium",
					description: "!text-tx-primary !font-medium",
					actionButton: "!bg-action-primary !text-tx-primary hover:!bg-action-primary-hover !font-medium",
					cancelButton: "!bg-float !text-tx-secondary hover:!bg-container-tertiary !font-medium",
					closeButton: "!bg-float !text-tx-secondary hover:!bg-container-primary"
				}
			}}
			{...props}
		/>
	);
};

export { Toaster };
